import axios from 'axios';
import Header from './Header';
import { useEffect, useState,useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiurl from './Api';
import RefreshContext from './Components/RefreshContext';

axios.defaults.withCredentials = true;

const ProtectedRoute = ({ children }) => {

  const { refreshKey } = useContext(RefreshContext);

  
  const [username, setUsername] = useState('');
  const [person_name, setNaam] = useState('');
  const [types, setTypes] = useState('');
  const [isOnline, setIsOnline] = useState(true);
  const [loading, setLoading] = useState(true); // session check loader
  const navigate = useNavigate();
  const location = useLocation();

  const segments = location.pathname.split("/");
  const lastSegment = segments[segments.length - 1];
  const aid = /^\d+$/.test(lastSegment) ? lastSegment : 0; // only if numeric

  // ✅ Detect Online/Offline events
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    if (!navigator.onLine) {
      setIsOnline(false);
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
    
  }, [refreshKey]);

  // ✅ Session check (only when online)
  useEffect(() => {
    const checkAuth = async () => {
      if (!navigator.onLine) {
        setLoading(false);
        return; // don't call API when offline
      }

      try {
        const response = await axios.post(apiurl + "session.php",new URLSearchParams({ aid: aid }));

        if (response.data.statuss === true) {
          setUsername(response.data.post);
          setNaam(response.data.banda_naam);
          setTypes(response.data.types);

          if (response.data.types === 'staff' && response.data.access === false) {
            navigate('/admin');
          }

          
        } else {
          console.error('Invalid token or other error:',response.data.messages);
          navigate('/'); // Redirect to login if session expired
        }
      } catch (error) {
        console.warn("Session check failed:", error.message);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate, aid,refreshKey]);

  if (!isOnline) {
    return (
    <div className="full-screen-overlay">
    <div className="card bg-white shadow-lg alert-card text-center">
        
        <div className="d-flex justify-content-center mb-4">
            <div className="spinner-border text-danger" role="status" style={{width: '3rem', height: '3rem'}}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>

        <h2 className="card-title text-danger fw-bold mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-wifi-off me-2" viewBox="0 0 16 16">
              <path d="M10.74 3.737C10.96 3.58 11.196 3.44 11.45 3.315 12.753 2.662 14.2 2.002 16 2l-2-2-3 3-2 2zM9.5 8.5c0 .248-.027.492-.078.732l1.096 1.096A4.996 4.996 0 0 0 11.5 8.5c0-.65-.135-1.266-.37-1.838l.937-.937c.365.69.583 1.488.583 2.775 0 .225-.015.447-.042.666l1.246 1.246c.158-.29.3-.588.423-.889 0 0 .003-.001.003-.001 0-.671-.24-1.31-.693-1.802L15 8l-2.739-2.739.006.007C11.666 5.86 11.5 6.444 11.5 7v1.5H9.5zM8 7.5a2 2 0 0 1 2 2c0 .265-.035.52-.102.76l1.243 1.243a3.5 3.5 0 0 0 1.258-2.003 3.5 3.5 0 0 0-3.5-3.5c-.714 0-1.385.195-1.956.54l1.036 1.036c.21-.11.442-.178.696-.178zM5 8.5c0-.986.376-1.884 1-2.58l.763.763A2.96 2.96 0 0 0 6.5 8.5c0 .484.148.94.42 1.332l.836.836C7.265 11.233 6.5 12 5.5 12c-1.88 0-3.41-1.36-3.49-3.23l1.96-1.96c.24.088.498.14.766.14.28 0 .546-.058.79-.16l1.036 1.036c-.456.28-.97.436-1.503.436-1.39 0-2.6-.74-3.35-1.94L0 7.5l2.738 2.738C1.59 9.946 0 8.76 0 7.5c0-1.684.88-3.193 2.373-3.957l.006-.006L5 7.5V8.5z"/>
            </svg>
            No Internet Connection
        </h2>
        
        <p className="card-text text-secondary mb-4">
            We've lost our signal. Please check your network and try again.
        </p>

        <button type="button" className="btn btn-primary fw-semibold" onClick={() => window.location.reload()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise me-1" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.96 2.22a.25.25 0 0 1 0 .384l-2.96 2.22a.25.25 0 0 1-.41-.192z"/>
            </svg>
            Attempt Reconnect
        </button>
        
    </div>
</div>
    );
  }

  // ✅ Loader while checking session
  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/90 z-50">
        <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <>
      <Header mobile={username} banda={person_name} ttypess={types} />
      {children}
    </>
  );
};

export default ProtectedRoute;
